// Fire a Qualified virtual page view on each client-side route transition.
// The Qualified loader (in src/components/SEO/index.jsx) auto-reports the
// initial page view, so we skip the first call (prevLocation === null).
export const onRouteUpdate = ({ prevLocation }) => {
  if (!prevLocation) {
    return; // initial load — already reported by the loader snippet
  }
  if (typeof window !== 'undefined' && typeof window.qualified === 'function') {
    try {
      const result = window.qualified('page');
      if (result && typeof result.catch === 'function') {
        result.catch(() => {});
      }
    } catch {
      // Qualified may reject on localhost (e.g. invalid_request)
    }
  }
};
